import { useEffect, useState } from "react"

import liposome_intro from "../assets/img/liposome_intro.png";

//icon formes
import gelule from "../assets/icons/gelule_orange.png";
import poudre from "../assets/icons/poudre_orange.png";
import liquide from "../assets/icons/liquide_orange.png";

//icon catégori
import categori1 from "../assets/icons/cate1.png";
import categori2 from "../assets/icons/cate2.png";
import categori3 from "../assets/icons/cate3.png";
import categori4 from "../assets/icons/cate4.png";

//icon liposome avantage
import corps from "../assets/icons/liposome_corps.png";
import schema from "../assets/icons/liposome_schema.png";

//icon liposome actif
import left_schema from "../assets/icons/liposome_left_schema.png";
import right_schema from "../assets/icons/liposome_right_schema.png";
import bottom_schema from "../assets/icons/liposome_botom_schema.png";

//icon otherProduct
import probiotique from "../assets/icons/homepage_probiotique.png";
import niosome from "../assets/icons/homepage_niosome.png";

//icon carousel
import icon_arrow_forward from '../assets/icons/arrow_forward.svg';
import icon_arrow_back from '../assets/icons/arrow_back.svg';

import '../styles/views/liposome.css'
import MoreInfo from "../components/MoreInfo";
import OtherProduct from '../components/OtherProduct';
import TabCatalogue from "../components/TabCatalogue";
import produits from "../assets/ProductContent/data/data.js";


export default function Liposome() {

    const [isMobile, setIsMobile] = useState(false);
    const [isCarousel, setIsCarousel] = useState(false)
    const [currentIndex, setCurrentIndex] = useState(0);


    const handlePrev = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? categories.length - 1 : prevIndex - 1
        );
    };

    const handleNext = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === categories.length - 1 ? 0 : prevIndex + 1
        );
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1050);
            setIsCarousel(window.innerWidth <= 1050);
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const categories = [
        [categori1, "Vitamines & minéraux", "Vitamine C, multivitamines,<br/> Fer, Zinc, Chrome…"],
        [categori2, "Antioxydants", "Glutathion, Quercétine,<br/> Resvératrol, Astaxanthine…"],
        [categori3, "Acides & coenzymes", "Acide Alpha-Lipoïque, NADH,<br/> Coenzyme Q10…"],
        [categori4, "Extraits végétaux", "Curcuma, Vigne Rouge,<br/> thé vert, chardon marie…"]
    ];


    return (
        <div>
            <div className="liposome_global-container">
                {isMobile ? (
                    // 📱 Version Mobile
                    <section className="liposome_intro-container">
                        <h1 className="liposome_intro-title">
                            <label className="bold font-42">Your supplier of <br /> liposomal active  <br /> ingredients </label>
                        </h1>
                        <img className="liposome_intro-img" src={liposome_intro} />
                        <p className="liposome_intro-subtitle">
                            <label className="orange-color">Liposomal technology </label> for food <br /> supplements with optimised absorption
                        </p>
                        <p className="liposome_intro-text">
                            Liposomal technology is a key innovation in the field of food supplements, providing enhanced absorption and improved bioavailability of active ingredients.
                            <br /><br />
                            Thanks to liposomes, tiny vesicles that encapsulate the ingredients, this technology ensures better protection and maximum delivery of nutrients to the body. They guarantee up to 95% of the active ingredients preserved.
                            <br /><br />
                            Unlike traditional forms, liposome food supplements offer enhanced, targeted effects and optimal assimilation, even for the most sensitive active ingredients.
                        </p>
                    </section>
                ) : (
                    // 💻 Version Desktop
                    <section className="liposome_intro-container">
                        <div className="liposome_introduction-text-container">
                            <h1 className="liposome_intro-title">
                                <label className="bold font-42">Your supplier of <br /> liposomal active  <br /> ingredients </label>
                            </h1>
                            <p className="liposome_intro-subtitle">
                                <label className="orange-color">Liposomal technology </label> for food <br /> supplements with optimised absorption
                            </p>
                            <p className="liposome_intro-text">
                                Liposomal technology is a key innovation in the field of food supplements, providing enhanced absorption and improved bioavailability of active ingredients.
                                <br /><br />
                                Thanks to liposomes, tiny vesicles that encapsulate the ingredients, this technology ensures better protection and maximum delivery of nutrients to the body. They guarantee up to 95% of the active ingredients preserved.
                                <br /><br />
                                Unlike traditional forms, liposome food supplements offer enhanced, targeted effects and optimal assimilation, even for the most sensitive active ingredients.
                            </p>
                            <MoreInfo label={"See our catalogue"} link={"download"} />
                        </div>
                        <img className="liposome_intro-img" src={liposome_intro} />
                    </section>
                )}
                <section className="liposome_forme-container">
                    <h2 className="liposome_forme-title">a wide<label className="orange-color"> range of active ingredients</label></h2>
                    <p className="liposome_forme-subtitle"><label className="orange-color">3 forms available :</label></p>
                    <div className="liposome_forme-icon-container">
                        <div className="liposome_forme-icon-item-container">
                            <img className="liposome_forme-icon" src={gelule} />
                            <p className="liposome_forme-text">CAPSULES</p>
                        </div>
                        <div className="liposome_forme-icon-container">
                            <div className="liposome_forme-icon-item-container">
                                <img className="liposome_forme-icon" src={poudre} />
                                <p className="liposome_forme-text">WATERDISPERSIBLE<br />POWDER</p>
                            </div>
                        </div>
                        <div className="liposome_forme-icon-container">
                            <div className="liposome_forme-icon-item-container">
                                <img className="liposome_forme-icon" src={liquide} />
                                <p className="liposome_forme-text">LIQUID</p>
                            </div>
                        </div>
                    </div>
                    <p className="liposome_forme-description-text">
                        Our laboratory offers a complete range of liposomal active ingredients specially formulated for food supplements.
                        All our ingredients are carefully selected to satisfy the high expectations of professionals and their consumers:
                    </p>
                    {isMobile ? (
                        <div className="liposome_forme-categori-container">
                            <img className="carousel_arrow left" src={icon_arrow_back} alt="Flèche gauche" onClick={handlePrev} />
                            <div className="carousel_item">
                                <img className="liposome_forme-categori-img" src={categories[currentIndex][0]} alt={categories[currentIndex][1]} />
                                <h4 className="liposome_forme-categori-title">{categories[currentIndex][1]}</h4>
                                <p className="liposome_forme-categori-text" dangerouslySetInnerHTML={{ __html: categories[currentIndex][2] }}></p>
                            </div>

                            <img className="carousel_arrow right" src={icon_arrow_forward} alt="Flèche droite" onClick={handleNext} />
                        </div>

                    ) :
                        (
                            <div className="liposome_forme-categori-container">
                                <div className="liposome_forme-categori-container-item">
                                    <img className="liposome_forme-categori-img" src={categori1} />
                                    <h4 className="liposome_forme-categori-title">Vitamins & minEraLS</h4>
                                    <p className="liposome_forme-categori-text">Vitamin C, multivitamins, IRON, <br /> Zinc, ChromIUM…</p>
                                </div>
                                <div className="liposome_forme-categori-container-item">
                                    <img className="liposome_forme-categori-img" src={categori2} />
                                    <h4 className="liposome_forme-categori-title">AntioxIdants</h4>
                                    <p className="liposome_forme-categori-text">Glutathione, Quercetin, <br /> Resveratrol, Astaxanthin...</p>
                                </div>
                                <div className="liposome_forme-categori-container-item">
                                    <img className="liposome_forme-categori-img" src={categori3} />
                                    <h4 className="liposome_forme-categori-title">Acids & coenzymes</h4>
                                    <p className="liposome_forme-categori-text">Alpha-Lipoic Acid, NADH, <br /> Coenzyme Q10...</p>
                                </div>
                                <div className="liposome_forme-categori-container-item">
                                    <img className="liposome_forme-categori-img" src={categori4} />
                                    <h4 className="liposome_forme-categori-title">Plant extracts</h4>
                                    <p className="liposome_forme-categori-text">Turmeric, red vine, green<br /> tea, milk thistle...</p>
                                </div>
                            </div>
                        )}
                </section>
                <section className="liposome_avantage-container">
                    <img className="liposome_avantage-img" src={corps} />
                    <div className="liposome_avantage-content-container">
                        <h3 className="liposome_avantage-title">The benefits of<label className="orange-color">liposomal <br/> active ingredients</label></h3>
                        <div className="liposome_avantage_rightImg-container">
                            <img className="liposome_avantage-img_right" src={schema} />
                        </div>
                        <p className="liposome_avantage-description">Liposomal technology offers several specific benefits for your food supplements:</p>
                        <div className="liposome_avantage-buletPoint-container">
                            <h4 className="liposome_avantage-buletPoint-title">✔ Maximum bioavailability :</h4>
                            <p className="liposome_avantage-buletPoint-text"> Thanks to liposomes, the active ingredients are protected and released directly into the digestive system, allowing complete assimilation.</p>
                        </div>
                        <div className="liposome_avantage-buletPoint-container">
                            <h4 className="liposome_avantage-buletPoint-title">✔ Protection of active ingredients :</h4>
                            <p className="liposome_avantage-buletPoint-text"> Liposomes preserve ingredients from digestive degradation, ensuring their integrity and efficiency.</p>
                        </div>
                        <div className="liposome_avantage-buletPoint-container">
                            <h4 className="liposome_avantage-buletPoint-title">✔ Targeted, gradual release :</h4>
                            <p className="liposome_avantage-buletPoint-text">Liposomes allow controlled diffusion of the active ingredients, prolonging their beneficial effects.</p>
                        </div>
                    </div>
                </section>
                <section className="liposome_listingMp-container">
                    <TabCatalogue produits={produits} type="liposome" />
                    <MoreInfo
                        label={"Contact us"}
                        link={"*"}
                    />
                </section>
                <section className="liposome_choice_global-container">
                    <h3 className="liposome_choice-title">Why choose our <label className="orange-color">liposomal active <br/> ingredients ?</label></h3>
                    <p className="liposome_choice-text">Choosing our liposome active ingredients means opting for high-performance ingredients and an advanced technology that significantly improves their efficiency. Our formulations are tailored to the needs of the dietary supplements market and offer impeccable quality, thanks to in-depth expertise and strict controls.</p>
                    <div className="liposome_choice-2bloc-container">
                        <div className="liposome_choice-leftBloc-container">
                            <h4 className="liposome_choice-leftBloc-title"><label className="orange-color">flexible</label> tailor-made production</h4>
                            <p className="liposome_choice-leftBloc-text">
                                We offer a flexible manufacturing solution, from small batches to large-scale production, to meet the specific needs of each brand.  
                                <br /><br />
                                Whether white label or custom development, our expertise guarantees optimum quality and efficacy for your liposome products.
                            </p>
                            <img className="liposome_choice-leftBloc-img" src={left_schema} />
                        </div>
                        <div className="liposome_choice-rightBloc-contaienr">
                            <h4 className="liposome_choice-rightBloc-title">Commitment to quality and  <br />
                                recognised certifications
                            </h4>
                            <p className="liposome_choice-rightBloc-text">Our standards guarantee complete traceability, from the selection of raw materials to the final product. 
                                <br /><br />
                                Our liposomal food supplements have international certifications attesting our commitment to quality (HACCP, GMP Food, Synadiet).
                            </p>
                            <img className="liposome_choice-rightBloc-img" src={right_schema} />
                        </div>
                    </div>
                    <div className="liposome_choice_bottomBloc-container">
                        <div className="liposome_choice_bottomBloc-description-container">
                            <h4 className="liposome_choice_bottomBloc-description-title">Full assistance <label className="orange-color">from <br /> formulation to market launch</label></h4>
                            <p className="liposome_choice_bottomBloc-description-text">Our laboratory is not limited to production: we support our customers at  every stage of their project, from the initial formulation right through to market launch.
                                <br /><br />
                                Our service also includes regulatory monitoring and packaging assistance, ensuring that your food supplements are both compliant and appealing for fast and effective launch on the market.
                            </p>
                        </div>
                        <img className="liposome_choice_bottomBloc-description-img" src={bottom_schema} />
                    </div>
                </section>
                <MoreInfo
                    label={"contact us"}
                    link={"*"}
                />
                <section className='formule_otherProduct_global-container'>
                    <h3 className='formule_otherCategory-title'><label className='bold'>our other</label><label className='orange-color'> ingredient categories</label></h3>
                    <OtherProduct
                        title1={"niosomes"}
                        subtitle1={"Cosmetics"}
                        img1={niosome}
                        link1={"/niosomes"}
                        title2={"Probiotiques & Postbiotiques"}
                        subtitle2={"VPRO® and PROLIPO® Technologies "}
                        img2={probiotique}
                        link2={"/probiotiques"}
                    />
                </section>
            </div>
        </div>
    );

}